import React, { useState } from 'react';
import '../styles/ServiceCenters.css';

// List of Nigerian states
const locations = [
  'Lagos', 'Abuja', 'Port Harcourt', 'Ibadan', 'Kano', 'Enugu', 'Kaduna', 'Benin City', 'Abeokuta', 'Jos',
  'Owerri', 'Ilorin', 'Uyo', 'Akure', 'Maiduguri', 'Asaba', 'Warri', 'Makurdi', 'Calabar', 'Minna',
  'Ado-Ekiti', 'Bauchi', 'Sokoto', 'Gombe', 'Yola', 'Jalingo', 'Lokoja', 'Osogbo', 'Abakaliki', 'Katsina',
  'Birnin Kebbi', 'Dutse', 'Damaturu', 'Gusau', 'Awka'
];

// Inverter brands
const inverterBrands = [
  'Luminous', 'Su-Kam', 'Felicity', 'Must Power', 'Blue Gate', 'Mercury', 'Smarten', 'Genus', 'Zelota', 'Sinergy',
  'PowerStar', 'Microtek', 'APC', 'Homage', 'Victron Energy', 'Huawei', 'Growatt', 'Helios', 'Renogy', 'SRNE',
  'Schneider Electric', 'Xantrex', 'Exide', 'Eastman', 'Prag', 'Qasa', 'iCellpower', 'TBB Power', 'Leoch', 'Studer Innotec',
  'Tesla Power', 'Trojan', 'Phoenix Contact', 'Chloride Exide', 'ABB', 'Alpha Power', 'Axpert', 'MPower', 'GreenRich',
  'PowerKing', 'SolarMax', 'Easun Power', 'APSystems', 'GoodWe', 'SMA Solar Technology', 'Fronius', 'InfiniSolar'
];

// Battery brands
const batteryBrands = [
  'Rubitec', 'LG Chem', 'Trojan', 'BYD', 'Felicity', 'NPP Power', 'Blue Nova', 'Pylontech', 'B3 Lithium', 'Narada',
  'Greenrich', 'Sako', 'Basalt', 'Sunfit', 'Infinity', 'Chloride Exide', 'ZLpower', 'Quanta', 'Crown Battery', 'Westa',
  'Eastman', 'Ritar', 'Genus', 'Leoch', 'SMA', 'Must Power', 'Hober', 'Victron Energy', 'Tesla Powerwall', 'Dyness',
  'Ulica Solar', 'Okaya', 'Shoto', 'Ubetter', 'Energizer', 'Lento', 'Panasonic', 'Microtek', 'SolarMax', 'Amaron Quanta'
];

// Verified service center data
const serviceCentersData = [
  // Luminous
  { name: "Luminous Service Center – Surulere", brand: "Luminous", type: "Inverter", location: "Lagos", address: "No. 65, Bode Thomas Road, Surulere, Lagos", phone: "0700 111 2233" },
  { name: "Luminous Service Center – Ikeja", brand: "Luminous", type: "Inverter", location: "Lagos", address: "52 Morrison Crescent, Oregun Industrial Area, Ikeja, Lagos", phone: "0700 111 2233" },
  { name: "Luminous Service Center – Lekki", brand: "Luminous", type: "Inverter", location: "Lagos", address: "1 Victoria Arobieke Street, Lekki Phase I, Lagos", phone: "0700 111 2233" },
  { name: "Luminous Service Center – Abuja", brand: "Luminous", type: "Inverter", location: "Abuja", address: "Plot 981, Central Business District, Beside Danziyal Plaza, opposite NNPC Mega Station, Zone 1, Abuja", phone: "0700 111 2233" },
  { name: "Luminous Service Center – Ibadan", brand: "Luminous", type: "Inverter", location: "Ibadan", address: "TCTC Compound, Idiope Eleyele, Ibadan, Oyo State", phone: "0700 111 2233" },

  // Victron
  { name: "SolarDepot Nigeria – Abuja", brand: "Victron Energy", type: "Inverter", location: "Abuja", address: "Flat 3, Block 17, Borno Street, Area 10, Garki, Abuja", phone: "07046946795" },
  { name: "SolarDepot Nigeria – Lagos", brand: "Victron Energy", type: "Inverter", location: "Lagos", address: "Adegbola Adigun Street, Greenfield Estate, OPIC, Lagos", phone: "07046946795" },

  // Su-Kam
  { name: "Su-Kam Power Systems (Simba Distributor / Service)", brand: "Su-Kam", type: "Inverter", location: "Lagos", address: "1 Olorunfunmi Street, off Oregun Road, Ojota, Ikeja, Lagos", phone: "+234 812 433 2975" },

  // Huawei
  { name: "Huawei Service Centre", brand: "Huawei", type: "Inverter", location: "Lagos", address: "4 Kodesoh Street, Computer Village, Ikeja, Lagos", phone: "+234 809 977 6644" },
  { name: "Huawei Branch Office / Service", brand: "Huawei", type: "Inverter", location: "Abuja", address: "2nd Floor, NDPHC House, Plot 1490, Samuel Ademulegun Street, Central Business District, Abuja", phone: "+234 9 4138715" },

  // Blue Gate
  { name: "Blue Gate Service Centre – Lagos Head Office", brand: "Blue Gate", type: "Inverter", location: "Lagos", address: "39 Akinremi Street, Ikeja, Lagos", phone: "+234 8022391475" },
  { name: "Blue Gate Service Centre – Abuja", brand: "Blue Gate", type: "Inverter", location: "Abuja", address: "Suite G7, Febson Mall, Off Herbert Macaulay Way, Wuse Zone 4, Abuja", phone: "+234 9077936081" },
  { name: "Blue Gate Service Centre – Port Harcourt", brand: "Blue Gate", type: "Inverter", location: "Port Harcourt", address: "No 20 Ede Street, off Ogbunabali Road, Port Harcourt", phone: "+234 9074908633" },

  // Growatt
  { name: "Sygnite (Growatt Partner) - Lekki", brand: "Growatt", type: "Inverter", location: "Lagos", address: "Chancery House, No. 5 C & I Leasing Drive, Lekki Phase 1, Lagos", phone: "+234 817 193 6361" },
  { name: "Gennex Technologies (Growatt Stockist)", brand: "Growatt", type: "Inverter", location: "Lagos", address: "Plot 25, Adebisi Ogunnuyi Crescent, off Oladimeji Alo Street, Ikate, Lekki, Lagos", phone: "+234 817 193 6361" },

  // SRNE
  { name: "HM Solar (SRNE Nigeria Contact)", brand: "SRNE", type: "Inverter", location: "Lagos", address: "Plot 2015, Amuwo-Festac Access Road, Amuwo-Odofin, Lagos", phone: "+234 803 449 0636", email: "info@hmsolarltd.com" },

  // Schneider
  { name: "Schneider Electric Nigeria", brand: "Schneider Electric", type: "Inverter", location: "Lagos", address: "26 Aromire Avenue, off Adeniyi Jones, Ikeja, Lagos", phone: "+234 1 277 8311" },

  // APC
  { name: "APC Nigeria HQ", brand: "APC", type: "Inverter", location: "Lagos", address: "1 Tunde Gafar Close, off Adeniyi Jones Avenue, Ikeja, Lagos", phone: "+234 807 797 6679" },

  // Felicity
  { name: "Felicity Solar Head Office", brand: "Felicity", type: "Inverter", location: "Lagos", address: "No 2, Omotosho Street, Durban Estate, Amuwo-Odofin, Lagos", phone: "+234 707 911 7572" },
  { name: "Felicity Solar Abuja Office", brand: "Felicity", type: "Inverter", location: "Abuja", address: "204 Anyim Pius Anyim Street, Utako, Abuja, FCT", phone: "+234 817 147 9561" }
];

function ServiceCenters() {
  const [type, setType] = useState('');
  const [brand, setBrand] = useState('');
  const [location, setLocation] = useState('');
  const [filteredCenters, setFilteredCenters] = useState([]);
  const [submitted, setSubmitted] = useState(false);

  const handleSearch = () => {
    const results = serviceCentersData.filter(center => {
      const matchesType = type ? center.type.toLowerCase().includes(type.toLowerCase()) : true;
      const matchesBrand = brand ? center.brand.toLowerCase() === brand.toLowerCase() : true;
      const matchesLocation = location
        ? center.location.toLowerCase().includes(location.toLowerCase())
        : true;
      return matchesType && matchesBrand && matchesLocation;
    });
    setFilteredCenters(results);
    setSubmitted(true);
  };

  return (
    <div className="service-centers-container">
      <section className="hero-sectioncenters">
        <div className="hero-overlay">
          <h1>Find Trusted Service Centers Near You</h1>
          <p>Quickly locate reliable Inverter and Battery support centers across all 36 states in Nigeria.</p>
        </div>
      </section>

      <img src="/images/servicecenters.png" alt="service centers" className="card-iconpanelservicecenters" />

      <div className="filters">
        <select value={type} onChange={e => setType(e.target.value)}>
          <option value="">Select Device Type</option>
          <option value="Inverter">Inverter</option>
          <option value="Battery">Battery</option>
        </select>

        <select value={brand} onChange={e => setBrand(e.target.value)} disabled={!type}>
          <option value="">Select Brand</option>
          {(type === 'Inverter' ? inverterBrands : type === 'Battery' ? batteryBrands : []).map((b, index) => (
            <option key={index} value={b}>{b}</option>
          ))}
        </select>

        <select value={location} onChange={e => setLocation(e.target.value)}>
          <option value="">Select Location</option>
          {locations.map((loc, idx) => (
            <option key={idx} value={loc}>{loc}</option>
          ))}
        </select>

        <button onClick={handleSearch}>Search</button>
      </div>

      {submitted && filteredCenters.length === 0 && (
        <div className="no-results">No service centers found for your selection.</div>
      )}

      {submitted && filteredCenters.map((center, idx) => (
        <div className="service-center-card" key={idx}>
          <h3>{center.name}</h3>
          <p><strong>Brand:</strong> {center.brand}</p>
          <p><strong>Type:</strong> {center.type}</p>
          <p><strong>Location:</strong> {center.location}</p>
          <p><strong>Address:</strong> {center.address}</p>
          {center.phone && <p><strong>Phone:</strong> {center.phone}</p>}
          {center.email && <p><strong>Email:</strong> {center.email}</p>}
        </div>
      ))}
    </div>
  );
}

export default ServiceCenters;
